import debounce from '../utils/debounce';

const QUERY = '.site-scroll-top';
const DELAY = 1000;

/**
 * This feature is used to setup scroll to top button behavior
 * 
 * @class ScrollToTop
 * @param {string} [query]
 * @param {number} [delay]
 */

export default class ScrollToTop {
    constructor(query = QUERY, delay = DELAY) {
        const el = document.querySelector(query);
        if (!el) throw new Error('Scroll to top button not found');

        this.el = el;
        this.delay = delay;

        this.init();
    }

    init () {
        this.handleClick();
        this.handleScroll();
    }

    handleClick () {
        this.el.addEventListener('click', (event) => {
            event.stopPropagation();

            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, this.delay);
        });
    }

    handleScroll () {
        const gth = this;
        const scrollPos = window.scrollY || window.pageYOffset;

        if (scrollPos > window.innerHeight) {
            this.el.classList.remove('hidden');
        } else {
            this.el.classList.add('hidden');
        }

        let prev = 0;
        window.addEventListener('scroll', (event) => {
            event.stopPropagation();

            (debounce(function () {
                const current = window.scrollY || window.pageYOffset;

                if (prev < current) {
                    gth.el.classList.add('hidden');
                } else {
                    if (current > window.innerHeight) {
                        gth.el.classList.remove('hidden');   
                    } else {
                        gth.el.classList.add('hidden');
                    }
                }

                prev = current;
            }))();
        });
    }
}

/**
 * Usage example
 * 
 * import ScrollToTop from 'components/scroll-top';
 * 
 * new ScrollToTop('.site-scroll-top', 500);
 * 
 */
